import {
  setListOfAustralianBusinessItems,
  setListOfNewZealandBusinessItems,
} from './business-lookup/set-business-items'

import {
  AU_LOOKUP_API_ENDPOINT,
  BUSINESS_LOOKUP_SELECTORS,
  COUNTRY_ISO_CODE,
  IS_NZ_STORE,
  NZ_LOOKUP_API_ENDPOINT,
} from './constants'

const selectors = BUSINESS_LOOKUP_SELECTORS[COUNTRY_ISO_CODE]

export const enableTestMode = (enableTestMode = false, step = 1, callback) =>
  step && enableTestMode && callback(step)

export const setMinimumDigitsInputHelperText = numbersRemaining => {
  let messageWithOneRemainingNumber = `There is ${numbersRemaining} number remaining`
  let messageWithMoreRemainingNumbers = `There are ${numbersRemaining} numbers remaining`
  return numbersRemaining > 1
    ? messageWithMoreRemainingNumbers
    : messageWithOneRemainingNumber
}

/**
 * Reset the Tick Icon on the Business Lookup search input fields
 * @param {*} numberSearchInput
 * @param {*} textSearchInput
 */
export const resetIsCompleteTickIcon = (numberSearchInput, textSearchInput) => {
  numberSearchInput.parentElement.classList.remove(`is-completed`)
  textSearchInput.parentElement.classList.remove(`is-completed`)
}

/**
 * Get formatted and constructed HTML list items by Country
 */
export const getBusinessListItemsByCountry = businesses => {
  return IS_NZ_STORE
    ? setListOfNewZealandBusinessItems(businesses)
    : setListOfAustralianBusinessItems(businesses)
}

/**
 * The ABN API returns 'items', whereas NZBN API returns 'entities'
 */
export const getFormattedListOfBusinesses = response =>
  IS_NZ_STORE ? response.items : response.entities

/**
 * Reset the ABN Lookup Dropdown List
 */
export function resetABNLookupResults() {
  const $els = {
    abnResultContainer: document.querySelector(`[data-results-abn]`),
    ABNFinder: document.querySelector(`#ABNFinder`),
    ABNTextSearchInput: document.querySelector(`#ABNTextSearchInput`),
    abnLookupLink: document.getElementById(`abn_lookup_link`),
  }
  if ($els.abnResultContainer) {
    // empty the result container if cleared & hide the result list.
    $els.abnResultContainer.innerHTML = ``
    $els.abnResultContainer.classList.add(`hide`)
  }
  if ($els.ABNFinder) {
    $els.ABNFinder.value = ``
  }
  if ($els.ABNTextSearchInput) {
    $els.ABNTextSearchInput.value = ``
  }
  if ($els.abnLookupLink) {
    $els.abnLookupLink.classList.remove(`hide`)
  }
  if ($els.ABNFinder) {
    $els.ABNFinder.parentElement.classList.remove(`is-completed`)
  }
  if ($els.ABNTextSearchInput) {
    $els.ABNTextSearchInput.parentElement.classList.remove(`is-completed`)
  }
}

/**
 * Reset the Selected Business Details & Clear Inputs
 */
export function resetSelectedBusinessDetails() {
  const elements = {
    $confirmDetailContainer: document.querySelector(
      selectors.confirmedBusinessDetailsContainerSelector
    ),
    $hiddenBusinessNumberInputField: document.querySelector(
      selectors.businessNumberHiddenInputSelector
    ),
    $hiddenLegalNameInputField: document.querySelector(
      selectors.legalNameInputSelector
    ),
    $hiddenPrivateLegalNameField: document.querySelector(
      selectors.privateLegalNameInputSelector
    ),
  }

  if (elements.$confirmDetailContainer) {
    elements.$confirmDetailContainer.classList.add(`hide`)
  }
  if (elements.$hiddenBusinessNumberInputField) {
    elements.$hiddenBusinessNumberInputField.value = ``
  }
  if (elements.$hiddenLegalNameInputField) {
    elements.$hiddenLegalNameInputField.value = ``
  }
  if (elements.$hiddenPrivateLegalNameField) {
    elements.$hiddenPrivateLegalNameField.value = ``
  }
}

/**
 * Adds event listeners to the dealer question fields on step 1 of application.
 */
export function addDealerEventListeners() {
  const params = new URLSearchParams(window.location.search)
  const dealer_select = document.querySelector(`input[name="application_has_dealer"]`)
  const dealerMessage = document.querySelector(`div#dealer_rep_details`)
  const dealershipInput = document.querySelector(`#dealer_name`)
  const dealerRepInput = document.querySelector(`#dealer_rep`)

  const affiliateId = params.get(`affiliate`)
  const contactId = params.get(`contact`)
  const dealerName = params.get(`dealer`)
  const repName = params.get(`salesperson`)

  if (dealerName) {
    dealer_select.value = `True`

    dealerMessage.classList.remove(`hidden`)

    dealershipInput.value = dealerName

    document.querySelector(`#dealer_affiliate_id`).value = affiliateId

    if (repName) {
      dealerRepInput.value = repName

      dealerMessage.innerHTML = `<p>Your dealer salesperson is&nbsp;<strong class="transifex-ignore">${repName}</strong>&nbsp;from&nbsp;<strong class="transifex-ignore">${dealerName}</strong></p>`
      document.querySelector(`#dealer_rep_id`).value = contactId
    } else {
      dealerMessage.innerHTML = `<p>You're working with our friends at&nbsp;<strong class="transifex-ignore">${dealerName}</strong></p>`
    }
  }
}

export function generateMedicareNameOptions() {
  let firstNameInput = document.getElementById(`first_name`)
  let hasMiddleNameInput = document.getElementById(`has_middle_name`)
  let middleNameInput = document.getElementById(`middle_name`)
  let lastNameInput = document.getElementById(`last_name`)
  let medicareNameField = document.getElementById(`Web_App_Medicare_Name_On_Card__c`)
  let currentSelection = medicareNameField.value

  let medicareNameOptions = [
      `${firstNameInput.value} ${lastNameInput.value}`
  ]

  if (
      hasMiddleNameInput.value === `y` &&
      middleNameInput.value
  ) {
    medicareNameOptions.push(
        `${firstNameInput.value} ${middleNameInput.value.slice(0,1)} ${lastNameInput.value}`,
        `${firstNameInput.value} ${middleNameInput.value} ${lastNameInput.value}`
    )
  }

  let html = `<option disabled value="" hidden selected>Please select your name as it appears on your medicare card</option>`
  medicareNameOptions.forEach(option => {
      html += `<option value="${option}"${currentSelection === option ? ` selected` : ``}>${option}</option>`
  })

  medicareNameField.innerHTML = html
}